
import { FormControl, Modal, Button, Container } from 'react-bootstrap';
import { useState } from "react";
import { ZipCodeLookupResult } from './ZipCodeLookupResult';

type ZipCodeLookupProps = {
    secureHeaders: Headers
    placeholder: string
    txtValue: string
    lookupResultHandler(result: ZipCodeLookupResult): void
    onZipChangeFunction : Function
    errorMessageHandler: Function
}

const ZipCodeLookup = (props: ZipCodeLookupProps) => {

    const { placeholder, txtValue } = props;
    const [zipSelector, setZipSelector] = useState<any>({ show: false })
    const [zipData, setZipData] = useState<any>({ dataList: [], selectedZipRecord: -0, zip: txtValue }) // current data for zipCode. 


    const zipCodeLookup = (zipCode: string) => {
      
        if (zipCode === "") {
            props.errorMessageHandler({ message: "Please enter zip code.", variant: "warning"});
            return;
        }
 
        if (zipCode === zipData.zip) {
            //console.log('Please get yourself updated first...');
            return;
        }

        // save some stuff
        const apiBase = sessionStorage.getItem("apibase");

        var _url = `${apiBase}/v1/ZipCode?zipCode=${zipCode}`;
        //console.log("Preparing to call api for zipCode lookup:" + _url);

        fetch(_url, { headers: props.secureHeaders })
            .then(response => response.json())
            .then((resp: any) => {
                if (resp.found) {
                   
                    // exact match found
                    if (resp.details.length == 1) {

                        // city,county,state,country
                        props.lookupResultHandler({
                            zipcode: zipCode,
                            city: resp.details[0].city,
                            county: resp.details[0].county,
                            state: resp.details[0].state,
                            country: resp.details[0].country
                        });

                        setZipData({...zipData, zip: txtValue });

                    } else {
                        setZipData({ dataList: resp.details, selectedZipRecord: -0, zip: txtValue  });
                        setZipSelector({ show: true });
                    }
                }
                else {
                    //console.log("Sorry not found");
                    props.errorMessageHandler({ message: "Zip code not found.", variant: "warning" });
                }
            });
    }


    const closeZipSelector = () => {
        if (zipData.selectedZipRecord !== -0) {
            // city,county,state,country
            props.lookupResultHandler({
                city: zipData.selectedZipRecord.split(',')[0],
                county: zipData.selectedZipRecord.split(',')[1],
                state: zipData.selectedZipRecord.split(',')[2],
                country: zipData.selectedZipRecord.split(',')[3],
                zipcode: zipData.selectedZipRecord.split(',')[4]
            });
            setZipSelector({ show: false });
        }
    }

    const onZipSelection = (e: any) => {
        
        if (e.target.value !== undefined) {
          
            setZipData({ dataList: zipData.dataList, selectedZipRecord: e.target.value, zip: txtValue });
        }
    }

    const onZipChange= (e: any) => {
        props.onZipChangeFunction(e);
    }

    return <>
        <FormControl
            placeholder={placeholder === null ? "Zip Code" : placeholder}
            aria-label="zipcode"
            aria-describedby="basic-addon1"
            value={txtValue}
            onBlur={(e) => zipCodeLookup(e.target.value)}
            onChange={onZipChange}
        />


        <Modal show={zipSelector.show} onHide={closeZipSelector}
            size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Please select the correct one</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <p>The zip code you entered can refer to different locations.</p>

                    <div key={"zipSelectorRadioList"} className="mb-3" onClick={onZipSelection} >
                        {zipData.dataList.map((item: any) => (
                            <div key={item.city + item.county + item.state}>
                                <input 
                                name="group1"
                                type={"radio"}
                                value={item.city + ", " + item.county + ", " + item.state + ", " + item.country + ", " + props.txtValue}
                                key={item.city + item.county}
                              id={`inline-${item.county}-1`} />
                            <label style={{ paddingLeft: "5px" }} htmlFor={`inline-${item.county}-1`}>{item.city + ", " + item.county + ", " + item.state + ", " + item.country}</label>
                                <br /></div>
                        ))}
                    </div>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <div className="w-100">
                    <Button onClick={closeZipSelector} className="ms-1 float-start">Save</Button>

                </div>
            </Modal.Footer>
        </Modal>
    </>

}

export default ZipCodeLookup;
